import React from 'react';
import Link from "next/link";
import {danaMediumFont} from "@/components/fonts/local.fonts";

const ElevatedLinkButton = (
    {children, href, target,
        bgColor,
        transition,
        duration,
        hover,
        focus,
        leading,
        textColor,
        textSize,
        fontWeight,
        padding,
        className,
        rounded
    }: {
        children: React.ReactNode;
        href: string;
        target?: string;
        bgColor?: string,
        transition?: string,
        duration?: number,
        hover?: string,
        focus?: string,
        leading?: string,
        textColor?: string,
        textSize?: string,
        fontWeight?: string,
        padding?: string,
        rounded?: string,
        className?: string,
    }) => {

    bgColor ??= 'bg-black dark:bg-white';
    transition ??= 'transition-all';
    duration ??= 300;
    hover ??= 'hover:bg-stone-600 dark:hover:bg-stone-300 hover:rounded-3xl';
    focus ??= '';
    textColor ??= 'text-white dark:text-black';
    textSize ??= 'text-sm';
    fontWeight ??= 'font-semibold';
    leading ??= 'leading-7';
    padding ??= 'py-1.5 px-4';
    rounded ??= 'rounded-xl'

    return (
        <Link
            type={'button'}
            href={href}
            target={target}
            className={`${danaMediumFont.className} ${transition} duration-${duration} ${bgColor} ${textColor} ${hover} ${focus} ${textSize} ${fontWeight} ${leading} ${padding} ${rounded} ${className}`}>
            {children}
        </Link>
    );
};

export default ElevatedLinkButton;
